<template>
  <div id="settings-wrapper">
    <!-- Quick Admin Tools -->
    <v-menu v-model="menu" :close-on-content-click="false" left offset-x nudge-left="8" transition="scale-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          id="admin-tools-btn"
          fab
          small
          color="white"
          elevation="3"
          class="admin-tools-btn"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon color="#455a64">mdi-tools</v-icon>
        </v-btn>
      </template>

      <v-card min-width="220" class="admin-tools-card">
        <v-list dense>
          <v-subheader class="admin-tools-heading">เครื่องมือผู้ดูแลระบบ</v-subheader>
          <v-list-item to="/admin/data_syslog">
            <v-list-item-icon>
              <v-icon color="#455a64">mdi-file-document-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Sys Log</v-list-item-title>
          </v-list-item>
          <v-list-item to="/admin/chatbot_manage">
            <v-list-item-icon>
              <v-icon color="primary">mdi-robot-happy-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>ผู้ช่วย HRVEC (Chatbot)</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="isSuperAdmin" to="/admin/security_monitor">
            <v-list-item-icon>
              <v-icon color="error">mdi-shield-alert-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Security Monitor</v-list-item-title>
          </v-list-item>
          <v-list-item @click="UpdateDateTime">
            <v-list-item-icon>
              <v-icon color="#455a64">mdi-calendar-sync-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Update DateTime</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>

    <!-- Scroll to top -->
    <transition>
      <v-btn
        v-show="scY > 300"
        fab
        small
        color="white"
        elevation="3"
        class="scroll-top-btn"
        @click="toTop"
      >
        <v-icon color="#455a64">mdi-chevron-up</v-icon>
      </v-btn>
    </transition>
  </div>
</template>

<script>
export default {
  name: "DashboardCoreSettings",

  data: () => ({
    ApiKey: "HRvec2021",
    menu: false,
    scTimer: 0,
    scY: 0,
    dataUpdate: {}
  }),

  computed: {
    isSuperAdmin() {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        return !!user && user.security_role === "SUPERADMIN";
      } catch (e) {
        return false;
      }
    }
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    UpdateDateTime() {
      this.menu = false;
      this.dataUpdate.ApiKey = this.ApiKey;
      Swal.fire({
        title: "คุณต้องการปรับปรุงปฏิทินระบบงานในฐานข้อมูล ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#b3151b",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก"
      }).then(async result => {
        if (result.isConfirmed) {
          await this.$http.post("updateCalendarPWHBegin.php", this.dataUpdate);
          await this.$http.post("updateCalendarPWHEnd.php", this.dataUpdate);
        }
      });
    },

    handleScroll: function () {
      if (this.scTimer) return;
      this.scTimer = setTimeout(() => {
        this.scY = window.scrollY;
        clearTimeout(this.scTimer);
        this.scTimer = 0;
      }, 100);
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style scoped>
#settings-wrapper {
  position: fixed;
  bottom: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  z-index: 6;
}

.admin-tools-btn,
.scroll-top-btn {
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
}

.admin-tools-card {
  border-radius: 12px !important;
}

.admin-tools-heading {
  font-weight: 600;
  font-size: 0.75rem;
  color: #718096;
}
</style>
